import pino from 'pino';

// Create a proper logger instance
const logger = pino({
  level: process.env.LOG_LEVEL ?? 'info',
  transport: process.env.NODE_ENV !== 'production' ? { target: 'pino-pretty' } : undefined,
  // Ensure timestamp is included in ISO format
  timestamp: pino.stdTimeFunctions.isoTime,
  // Custom formatting to ensure consistent structure
  formatters: {
    level: (label) => {
      return { level: label };
    },
  },
});

type LogData = Record<string, unknown>;

// Augment logger with structured methods that always use object format
const structuredLogger = {
  ...logger,
  debug: (msg: string | LogData, obj: LogData = {}) => {
    if (typeof msg === 'string' && obj) {
      logger.debug({ msg, data: obj });
    } else if (typeof msg === 'object') {
      logger.debug(msg);
    } else {
      logger.debug({ msg });
    }
  },
  info: (msg: string | LogData, obj: LogData = {}) => {
    if (typeof msg === 'string' && obj) {
      logger.info({ msg, data: obj });
    } else if (typeof msg === 'object') {
      logger.info(msg);
    } else {
      logger.info({ msg });
    }
  },
  warn: (msg: string | LogData, obj: LogData = {}) => {
    if (typeof msg === 'string' && obj) {
      logger.warn({ msg, data: obj });
    } else if (typeof msg === 'object') {
      logger.warn(msg);
    } else {
      logger.warn({ msg });
    }
  },
  error: (msg: string | LogData | Error, obj: LogData = {}) => {
    if (msg instanceof Error) {
      logger.error({
        msg: msg.message,
        error: {
          name: msg.name,
          message: msg.message,
          stack: msg.stack,
        },
        ...obj, // Merge any additional data passed
      });
    } else if (typeof msg === 'string' && obj) {
      logger.error({ msg, data: obj });
    } else if (typeof msg === 'object') {
      logger.error(msg);
    } else {
      logger.error({ msg });
    }
  },
};

export default structuredLogger;
